export enum ListMode {
  CARDS = "CARDS",
  TABLE = "TABLE",
}

// TODO: AK-3268
export enum FieldErrorType {
  Duplicate = "duplicate",
}

export enum AddressFormat {
  VeryShort = "VERY_SHORT",
  Short = "SHORT",
  Medium = "MEDIUM",
  Long = "LONG",
  AddressOnly = "ADDRESS_ONLY",
  LocationDescription = "LOCATION_DESCRIPTION",
  LocationAndAddress = "LOCATION_AND_ADDRESS",
  Shipping = "SHIPPING",
  BillTo = "BILL_TO",
}

export type DialogCloseAction = "close" | "cancel" | "success" | "backdropClick" | "escapeKeyDown"

export interface ActionOutcome<T = void> {
  /* @deprecated Use data instead */
  success?: boolean
  data?: T
  error?: Error
}
